import { isTruthyString } from './core.js';

/**
 * Concatenate valid string into classname
 * @param props arguments to concatenate
 * @returns final classname
 */
// eslint-disable-next-line import/prefer-default-export, no-underscore-dangle
function _cs() {
  for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
    props[_key] = arguments[_key];
  }
  return props.filter(isTruthyString).join(' ');
}

export { _cs };
//# sourceMappingURL=cs.js.map
